<template>
  <b-container class="p-0">
    <b-row class="m-0">
      <b-col class="p-0">
        <div class="profile-picture-container">
          <b-row>
            <b-col>
                <div v-if="companyInfo.url !== userInfo.company">
                  <b-button
                    v-if="!companyFollowStatus"
                    class="other-profile-follow-btn"
                    squared
                    variant="info"
                    @click="followReq"
                    ><i class="far fa-eye"></i> Follow
                  </b-button>
                  <b-button
                    v-else
                    class="other-profile-follow-btn"
                    squared
                    variant="info"
                    @click="UnFollowReq"
                  >
                    <i class="far fa-eye-slash"></i> Unfollow
                  </b-button>
                </div>
              <b-img :src="companyInfo.logo" fluid></b-img>

            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: $route.params.companyId },
                }"
              >
                <b-button class="go-to-profile-btn" block squared
                  >PROFILE</b-button
                >
              </router-link>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col class="text-center">
              <h2 class="bigName">
                {{ companyInfo.name }}
              </h2>
              <p class="big-work-info">{{ companyInfo.address }}</p>
            </b-col>
          </b-row>
          <hr class="user-profile-hr" />
          <b-row class="mb-3 mt-3" v-if="companyInfo.tag_details && companyInfo.tag_details.length">
            <b-col>
              <div class="profile-segments-div">
                <b-badge
                  v-for="segment in companyInfo.tag_details"
                  :key="segment.id"
                  class="profile-segment"
                  variant="dark"
                >
                  {{ segment.name }}
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <notifications group="profile" position="bottom left" />
  </b-container>
</template>

<script>
import CompanyProfile from '../../utils/mixins/CompanyProfile';

export default {
  name: 'OtherCompanyProfile',
  mixins: [CompanyProfile],
};

</script>
<style scoped>
.profile-picture-container {
  background: white;
}
.profile-picture {
  height: 280px;
  width: 100%;
  background-size: cover;
  background-position: center;
}
.profile-segments-div {
  padding: 0 15px 0 15px;
  text-align: left;
}
.profile-segments-div > span {
  border-radius: 0 8px 8px 8px;
}
.profile-segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #aaaaaa;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: white;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.profile-message-btn {
  font-size: 14px;
  text-align: center;
  box-shadow: none;
  min-height: 30px;
  min-width: 30px;
}
.profile-follow-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 14px;
  text-align: center;
  border: 0;
  border-left: 1px solid white;
  box-shadow: none;
  min-height: 30px;
  min-width: 30px;
}
.profile-message-icon,
.profile-follow-icon {
  font-size: 13.5px;
}
.go-to-profile-btn {
  background-color: #bd9d5f;
  box-shadow: none;
  border: 0;
  font-family: Arial;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  margin-top: 1px;
}
.go-to-profile-btn:active,
.other-profile-follow-btn,
.profile-message-btn,
.profile-follow-btn {
  box-shadow: none !important;
  border: 1px solid #bd9d5f;
  background-color: #bd9d5f;
  color: #fff;
}
.other-profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.bigName {
  color: #333333;
  font-size: 22px;
  font-weight: bold;
  padding-top: 17px;
  text-transform: capitalize;
  margin: 0;
}
.big-work-info {
  color: gray;
}
.big-profile-text,
.big-work-info {
  font-size: 14px;
  margin-bottom: 0rem;
  padding-bottom: 15px;
  text-transform: capitalize;
  padding: 0;
}
.big-profile-text {
  color: #bd9d5f;
}
.user-profile-hr {
  background: whitesmoke;
  margin: 0rem;
}
.Unfriend {
  background-color: #aaa !important;
}
.congratulationModal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulationModal a,
.congratulationModal button {
  color: #bd9d5f;
  background-color: #fff;
  border: 1px solid #bd9d5f;
  padding: 3px 10px;
  margin-right: 10px;
}
.congratulationModal a:hover,
.congratulationModal button:hover {
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #fff;
}
</style>
